import { select } from 'd3-selection';
import { drag } from 'd3-drag';

export const d3 = {
  select,
  drag,
};
